import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=01849b64"
import script from "./InboxPage.vue?vue&type=script&lang=js"
export * from "./InboxPage.vue?vue&type=script&lang=js"
import style1 from "./InboxPage.vue?vue&type=style&index=1&id=01849b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports